import gql from 'graphql-tag'

export default gql`
  mutation course_projects_create_mutation(
    $description: String
    $finishedUrl: String
    $image: Upload!
    # $links: [CourseAssetLinkCreateInput!]
    # $files: [CourseAssetFileCreateInput!]
    $slug: String!
    $title: String!
    $briefUrl: String
  ) {
    courseProjectCreate(
      description: $description
      finishedUrl: $finishedUrl
      image: $image
      # files: $files
      # links: $links
      slug: $slug
      title: $title
      briefUrl: $briefUrl
    ) {
      id
    }
  }
`
